import { Component, OnInit, Input, ViewChild } from "@angular/core";
import { PlantingSiteAreaDto } from "src/app/models/trofaco/plantingSiteAreaDto";
import { PlantingSiteService } from "src/app/modules/core/services/planting-site.service";
import { ConfirmDeleteModalComponent } from "src/app/modules/core/components/delete-modal/confirm-delete-modal-component";
import { AppUserModel } from "src/app/models/users/app-user.model";
import { ArrayHelper } from "src/app/models/helpers/array-helper";
import { ActivatedRoute, Router } from "@angular/router";
import { distinctUntilChanged, map } from "rxjs/operators";
import { combineLatest } from "rxjs";

type getColumnValue = (
    site: PlantingSiteAreaDto
) => number | string | undefined;
type Column = {
    key: string;
    property: getColumnValue;
    title: string;
    textRight?: boolean;
};

@Component({
    selector: "app-areas",
    templateUrl: "./areas.component.html",
    styleUrls: ["./areas.component.css"],
})
export class AreasComponent implements OnInit {
    @ViewChild(ConfirmDeleteModalComponent, { static: false })
    confirmDeleteModal: ConfirmDeleteModalComponent;

    @Input()
     plantingSiteAreas: PlantingSiteAreaDto[] = [];

    @Input()
    currentUser: AppUserModel;

    @Input()
    plantingSiteId: string;
    // _areas: PlantingSiteAreaDto[] = [];

    // @Input("areas")
    // set areas(areas: PlantingSiteAreaDto[]) {
    //     this._areas = areas;
    //     this.sortByChanged();
    // }

    private readonly confirmDeleteMsg = "Are you sure you want to delete";

    columns: Column[] = [
        { key: "areaNo", title: "Planting Area #", property: (areas) => areas.code },
        { key: "name", title: "Name", property: (areas) => areas.name },
        { key: "color", title: "Color", property: (areas) => areas.colorCode },
        { key: "year", title: "Year", property: (areas) => areas.year },
        { key: "kml", title: "KML", property: (areas) => areas.kmlUrl },
        { key: "flightPath", title: "Flight path", property: (areas) => areas.flightPathUrl},
    ];
    sortColumn = this.columns[0];
    sortAsc = true;
    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private plantingSiteService: PlantingSiteService
    ) {}

    async ngOnInit() {
        let sort$ = this.route.queryParamMap.pipe(
            map((map) => map.get("sort") || this.columns[0].key),
            distinctUntilChanged()
        );

        let sortAsc$ = this.route.queryParamMap.pipe(
            map((map) => map.get("sortAsc") || "true"),
            distinctUntilChanged()
        );

        combineLatest([sort$, sortAsc$]).subscribe(([sortKey, sortAsc]) => {
            let column = this.columns.find((value) => value.key == sortKey);
            if (column) {
                this.sortColumn = column;
            }
            this.sortAsc = sortAsc === "true";
            this.sortByChanged();
        });
    }

    async delete(area: PlantingSiteAreaDto) {
        let result = await this.confirmDeleteModal.showAwait(
            this.confirmDeleteMsg
        );

        if (result) {
            await this.plantingSiteService.deletePlantingSiteArea(area.id);
            let index = this.plantingSiteAreas.findIndex(
                (x) => x.id == area.id
            );
            this.plantingSiteAreas.splice(index, 1);
        }
    }

    sortBy(column: Column) {
        if (this.sortColumn == column) {
            this.sortAsc = !this.sortAsc;
        } else {
            this.sortColumn = column;
            this.sortAsc = true;
        }
        let sortKey = this.sortColumn.key;
        this.router.navigate([], {
            queryParamsHandling: "merge",
            replaceUrl: true,
            relativeTo: this.route,
            queryParams: { sort: sortKey, sortAsc: this.sortAsc },
        });
    }
    sortByChanged() {
        this.plantingSiteAreas = ArrayHelper.sortBy(this.plantingSiteAreas, this.sortAsc, this.sortColumn.property);
    }
}
